<script lang="ts">
  import type { IconDefinition } from '@fortawesome/fontawesome-svg-core'
  import Icon from './Icon.svelte'

  let { icon }: { icon: IconDefinition } = $props()
</script>

<span class="mirrored-icon"><Icon {icon} /></span>

<style>
  .mirrored-icon {
    display: inline-flex;

    &:dir(rtl) {
      transform: scaleX(-1);
    }
  }
</style>
